import { render, staticRenderFns } from "./editSKU.vue?vue&type=template&id=f5388d6e&scoped=true"
import script from "./editSKU.vue?vue&type=script&lang=js"
export * from "./editSKU.vue?vue&type=script&lang=js"
import style0 from "./editSKU.vue?vue&type=style&index=0&id=f5388d6e&prod&lang=scss&scoped=true"
import style1 from "./editSKU.vue?vue&type=style&index=1&id=f5388d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5388d6e",
  null
  
)

export default component.exports